import CardNumber from "./Common/CardNumber";

const Card = () => (
  <>
    <div className="pt-20 px-4 pb-4 md:py-16 md:px-10 xl:pt-24 xl:pb-16 xl:px-32 flex justify-start">
      <div className="md:pl-4 xl:pl-16 w-1/2">
        <CardNumber
          description="About this project"
          number="01"
          title="INTRODUCTION"
        />
      </div>
    </div>
    <div className="flex justify-end text-justify px-4 pb-8 md:pb-0 md:pr-16 md:pl-10 xl:pl-0">
      <div className="w-full xl:w-8/12">
        <p className="text-sm md:text-base font-normal pt-8 md:pt-0 mb-4">
          <span className="font-josefin">
            The dream of 2 young entrepreneurs was to connect people using
            Social networking app through advanced NFC technology. It was
            founded based on three simple terms, QUICK - EASY - USER FRIENDLY.
            How about having a simple app that will allow users to connect
            personally and professionally with a single tap.
          </span>
        </p>
        <p className="text-sm md:text-base font-normal pt-8 md:pt-0 mb-4">
          <span className="font-josefin">
            The app allows users to securely create and store their social and
            business profiles on a server, and with a single NFC tap, you can
            view and connect with them. Started as an MVP to test the idea, it
            is gaining massive traction across the UK, including Universities,
            bars, restaurants and many more public places.
          </span>
        </p>
      </div>
    </div>
    <div className="flex justify-end text-justify px-4 pb-8 md:pb-0 md:pr-16 md:pl-10 xl:pl-0">
      <div className="w-full xl:w-8/12">
        <div className="flex flex-col xl:flex-row pb-8 md:py-16">
          <div className="w-full xl:w-1/2">
            <div className="pr-4 pb-4 md:pr-8 md:pb-0">
              <h3 className="text-lg font-medium text-erie-black mb-2">
                <span className="font-josefin">Tap to Connect</span>
              </h3>
              <p className="text-base md:text-sm font-light text-erie-black mb-4">
                <span className="font-josefin">
                  Just tap on the NFC tag and connect with them on Instagram,
                  Facebook, Linkedin and many more.
                </span>
              </p>
            </div>
          </div>
          <div className="w-full xl:w-1/2">
            <div className="pr-4 pb-4 md:pr-8 md:pb-0">
              <h3 className="text-lg font-medium text-erie-black mb-2">
                <span className="font-josefin">Grow your Network</span>
              </h3>
              <p className="text-base md:text-sm font-light text-erie-black mb-4">
                <span className="font-josefin">
                  The cheapest way to grow your network with like-minded people
                  controlling who can find you easily directly on all your
                  networks.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Card;
